// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-billboards-tab {
  width: 600px;
  border-radius: 0.625rem;
  height: 3.185rem;
  display: inline-flex;
  padding: 0.5rem 0rem;
  align-items: center;
  gap: 0.875rem;
  margin-top: 30px;
  cursor: pointer;
}
.produuct-nill-tag {
  color: #000;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-h6, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: 25.6px;
}
.billboards-length {
  padding: 0.5rem;
  border-radius: 10px;
  background: #f5f5f5;
}
.ant-segmented.ant-segmented-sm .ant-segmented-item {
  border-radius: 10px;
}
.ai-recommondations-length {
  border-radius: 0.1875rem;
  background: #fff;
  padding: 0.5rem;
}

.ai-recommondations {
  display: inline-flex;
  padding: 0.5rem 1.25rem;
  align-items: center;
  gap: 0.875rem;
  border-color: 0;
  cursor: pointer;
}

.billBoards-table {
  margin-top: 30px;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
}

.billboard-status {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 700;
  width: 12rem;
  height: 3rem;
  margin-left: 2rem;
  border-radius: 0rem 0rem 0rem 0.625rem;
}
.available {
  background: var(--Colors-Secondary-100, #b0d9c4);
}
.sold-out {
  color: #000;
  background: var(--Colors-Secondary-100, #ffdbe3);
}
.billboards-table-header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.billboards-table-footer {
  color: var(--Colors-Primary-500, #d2042d);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-bottom: 1rem;
  padding-right: 2.5rem;
}

.campaign-billboard-add-section {
  display: flex;
  margin-right: 0.5rem;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

.billboard-checkbox .ant-checkbox-inner {
  width: 15px !important;
  height: 15px !important;
}

.billboard-checkbox .ant-checkbox {
  transform: scale(1.5) !important;
}

.billboard-values {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 600;
}

.delete-btn {
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: #d2042d;
}

.unit-quantitiy {
  margin-top: 30px;
  color: #d2042d;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.add-product-campaign {
  background-color: #d2042d;
}
.add-product-campaign-txt {
  color: #fff;
}
.add-product-campaign:hover {
  background-color: #d2042d !important;
  border: #d2042d !important;
}

.campaign-billboard-main-div {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.campaign-product-row {
  padding: 1.5rem;
  width: 100%;
  display: flex;
  align-items: flex-start;
}

.campaign-price-actions-div {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  padding-top: 2.5rem;
}
.move-product-text {
  font-family: Roboto !important;
  font-weight: 500 !important;
  font-style: Medium !important;
  font-size: 13px !important;
  line-height: 19.5px !important;
  letter-spacing: 0px !important;
  color: #d2042d !important;
  cursor: pointer;
  margin-top: 10px;
  text-decoration: underline;
}
.campaign-divider-new {
  width: 91% !important;
  height: 1px !important;
  background-color: #e5e5e5 !important;
  margin: 2px 0 !important;
}
.billboards-image {
  border-radius: 8px;
  width: 8.875rem;
  height: 10.125rem;
}

.campaign-billboard-checkbox-div {
  width: 90px;
  text-align: center;
  display: flex;
  justify-content: center;
}
.re-designed-product-col {
  width: 80% !important;
  display: flex !important;
  flex-direction: row !important;
}
.campaign-details-page-alignment-col {
  width: 60% !important;
}
.campaign-status-actions-row {
  display: flex !important;
  flex-direction: row !important;
  gap: 5px !important;
}
.campaign-total-price-section {
  display: flex !important;
  flex-direction: column !important;
  margin-top: 2% !important;
}
.campaign-billboard-add-section-div {
  display: flex !important;
  flex-direction: row !important;
  gap: 5% !important;
  align-items: center !important;
  justify-content: center !important;
}
.campaign-quantity-controls {
  display: flex;
  flex-direction: row;
  gap: 5%;
  align-items: center;
  justify-content: center;
}
.campaign-divider-row {
  display: flex !important;
  justify-content: flex-end !important;
  padding-right: 4% !important;
  margin-top: 10px !important;
}
.campaign-product-details-row {
  display: flex !important;
  justify-content: space-around !important;
  margin-top: 20px !important;
}
.re-designed-image-container {
  width: 10% !important;
}
.re-designed-campaign-price-actions-div {
  display: flex;
  flex-direction: row;
  gap: 5px;
}
.border-radios-color-grey {
  font-size: 11px !important;
  border-color: #d9d9d9 !important;
}
@media (max-width: 768px) {
  .my-billboards-tab {
    margin-top: 0rem;
    font-size: 12px;
    width: 90vw !important;
  }
  .billBoards-table {
    margin-top: 1.87rem;
    border-radius: 0.625rem;
    padding: 25px;
    background: #fff;
    box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
  }
  .campaign-billboard-add-section {
    display: flex;
    margin-right: 0.5rem;

    padding: 0.75rem;
    justify-content: center;
    align-items: center;
    gap: 1rem;
  }
}

@media (max-width: 375px) {
  .ai-recommondations {
    font-size: 12px;
  }
}

@media (max-width: 1440px) {
  .billboards-image {
    border-radius: 8;
    width: 5.875rem;
    height: 7.125rem;
  }
  .campaign-icons {
    height: 28px;
    width: 28px;
  }

  .billboard-values {
    font-size: 12px;
  }
}

@media (max-width: 1024px) {
  .billboards-image {
    border-radius: 8;
    width: 5.875rem !important;
    height: 7.125rem !important;
  }
}
@media (max-width: 1024px) {
  .billBoards-table {
    position: relative;
  }

  .billboard-status {
    position: absolute;
    top: 0px;
    right: 0px;
    padding: 4px 8px;
    background-color: #d2042d;
    color: white;
    font-weight: bold;
    border-radius: 0rem 0rem 0rem 0.625rem;
    z-index: 10;
    height: 40px;
  }

  .billboard-status.available {
    color: #000;
    background-color: #b0d9c4;
  }

  .billboard-status.sold-out {
    background-color: #d2042d;
  }

  .billboards-table-header {
    justify-content: flex-start !important;
  }
  .re-designed-product-col {
    width: 100% !important;
  }
  .re-designed-image-container {
    width: 13% !important;
  }
  .product-available-offer-action-col {
    width: 100% !important;
  }
  .re-designed-campaign-price-actions-div {
    display: flex;
    justify-content: flex-end;
  }
  .campaign-total-price-section {
    margin-right: 0% !important;
  }
  .campaign-quantity-controls {
    gap: 1%;
    align-items: center;
    justify-content: flex-end;
  }
  .common-text-color-red-10 {
    display: flex;
    justify-content: flex-end;
  }
  .unit-quantitiy {
    margin-top: 0px;
  }
}
@media (max-width: 768px) {
  .re-designed-image-container {
    width: 20% !important;
  }
  .campaign-quantity-controls {
    gap: 2%;
    align-items: center;
    justify-content: flex-end;
  }
}
@media (max-width: 425px) {
  .re-designed-image-container {
    width: 33% !important;
  }
  .mobile-response-details-col {
    display: flex;
    flex-direction: column !important;
    align-items: flex-end !important;
  }
  .campaign-product-details-row {
    justify-content: space-between !important;
  }
  .campaign-quantity-controls {
    gap: 3%;
    align-items: center;
    justify-content: flex-end;
  }
}
@media (max-width: 375px) {
  .re-designed-product-col {
    width: 100% !important;
    flex-direction: column !important;
  }
  .campaign-details-page-alignment-col {
    width: 100% !important;
  }
  .re-designed-image-container {
    width: 20% !important;
  }
  .mobile-response-details-col {
    display: flex;
    flex-direction: column !important;
    align-items: flex-end !important;
  }
  .campaign-product-details-row {
    justify-content: space-between !important;
  }
  .campaign-more-actions-mobile-container {
    max-width: 100%;
    overflow-x: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/campaigns/campaignbillboards/CampaignBillboardTable.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;AACxC;AACA;EACE,gDAAgD;AAClD;AACA;EACE,WAAW;EACX,gDAAgD;AAClD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,oCAAoC;EACpC,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;AAChC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kBAAkB;EAClB,8BAA8B;EAC9B,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,wCAAwC;EACxC,2BAA2B;AAC7B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,kDAAkD;EACpD;EACA;IACE,aAAa;IACb,oBAAoB;;IAEpB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,sCAAsC;IACtC,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sCAAsC;EACxC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,yBAAyB;EAC3B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,OAAO;IACP,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,OAAO;IACP,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,iCAAiC;IACjC,gCAAgC;EAClC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,OAAO;IACP,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,sBAAsB;IACtB,iCAAiC;EACnC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,iCAAiC;IACjC,gCAAgC;EAClC;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".my-billboards-tab {\n  width: 600px;\n  border-radius: 0.625rem;\n  height: 3.185rem;\n  display: inline-flex;\n  padding: 0.5rem 0rem;\n  align-items: center;\n  gap: 0.875rem;\n  margin-top: 30px;\n  cursor: pointer;\n}\n.produuct-nill-tag {\n  color: #000;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-h6, 16px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 25.6px;\n}\n.billboards-length {\n  padding: 0.5rem;\n  border-radius: 10px;\n  background: #f5f5f5;\n}\n.ant-segmented.ant-segmented-sm .ant-segmented-item {\n  border-radius: 10px;\n}\n.ai-recommondations-length {\n  border-radius: 0.1875rem;\n  background: #fff;\n  padding: 0.5rem;\n}\n\n.ai-recommondations {\n  display: inline-flex;\n  padding: 0.5rem 1.25rem;\n  align-items: center;\n  gap: 0.875rem;\n  border-color: 0;\n  cursor: pointer;\n}\n\n.billBoards-table {\n  margin-top: 30px;\n  border-radius: 0.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n}\n\n.billboard-status {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  font-weight: 700;\n  width: 12rem;\n  height: 3rem;\n  margin-left: 2rem;\n  border-radius: 0rem 0rem 0rem 0.625rem;\n}\n.available {\n  background: var(--Colors-Secondary-100, #b0d9c4);\n}\n.sold-out {\n  color: #000;\n  background: var(--Colors-Secondary-100, #ffdbe3);\n}\n.billboards-table-header {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.billboards-table-footer {\n  color: var(--Colors-Primary-500, #d2042d);\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding-bottom: 1rem;\n  padding-right: 2.5rem;\n}\n\n.campaign-billboard-add-section {\n  display: flex;\n  margin-right: 0.5rem;\n  padding: 0.5rem;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n}\n\n.billboard-checkbox .ant-checkbox-inner {\n  width: 15px !important;\n  height: 15px !important;\n}\n\n.billboard-checkbox .ant-checkbox {\n  transform: scale(1.5) !important;\n}\n\n.billboard-values {\n  font-family: Roboto;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.delete-btn {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  color: #d2042d;\n}\n\n.unit-quantitiy {\n  margin-top: 30px;\n  color: #d2042d;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n.add-product-campaign {\n  background-color: #d2042d;\n}\n.add-product-campaign-txt {\n  color: #fff;\n}\n.add-product-campaign:hover {\n  background-color: #d2042d !important;\n  border: #d2042d !important;\n}\n\n.campaign-billboard-main-div {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.campaign-product-row {\n  padding: 1.5rem;\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n}\n\n.campaign-price-actions-div {\n  align-items: flex-end;\n  display: flex;\n  flex-direction: column;\n  padding-top: 2.5rem;\n}\n.move-product-text {\n  font-family: Roboto !important;\n  font-weight: 500 !important;\n  font-style: Medium !important;\n  font-size: 13px !important;\n  line-height: 19.5px !important;\n  letter-spacing: 0px !important;\n  color: #d2042d !important;\n  cursor: pointer;\n  margin-top: 10px;\n  text-decoration: underline;\n}\n.campaign-divider-new {\n  width: 91% !important;\n  height: 1px !important;\n  background-color: #e5e5e5 !important;\n  margin: 2px 0 !important;\n}\n.billboards-image {\n  border-radius: 8px;\n  width: 8.875rem;\n  height: 10.125rem;\n}\n\n.campaign-billboard-checkbox-div {\n  width: 90px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n}\n.re-designed-product-col {\n  width: 80% !important;\n  display: flex !important;\n  flex-direction: row !important;\n}\n.campaign-details-page-alignment-col {\n  width: 60% !important;\n}\n.campaign-status-actions-row {\n  display: flex !important;\n  flex-direction: row !important;\n  gap: 5px !important;\n}\n.campaign-total-price-section {\n  display: flex !important;\n  flex-direction: column !important;\n  margin-top: 2% !important;\n}\n.campaign-billboard-add-section-div {\n  display: flex !important;\n  flex-direction: row !important;\n  gap: 5% !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n.campaign-quantity-controls {\n  display: flex;\n  flex-direction: row;\n  gap: 5%;\n  align-items: center;\n  justify-content: center;\n}\n.campaign-divider-row {\n  display: flex !important;\n  justify-content: flex-end !important;\n  padding-right: 4% !important;\n  margin-top: 10px !important;\n}\n.campaign-product-details-row {\n  display: flex !important;\n  justify-content: space-around !important;\n  margin-top: 20px !important;\n}\n.re-designed-image-container {\n  width: 10% !important;\n}\n.re-designed-campaign-price-actions-div {\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n}\n.border-radios-color-grey {\n  font-size: 11px !important;\n  border-color: #d9d9d9 !important;\n}\n@media (max-width: 768px) {\n  .my-billboards-tab {\n    margin-top: 0rem;\n    font-size: 12px;\n    width: 90vw !important;\n  }\n  .billBoards-table {\n    margin-top: 1.87rem;\n    border-radius: 0.625rem;\n    padding: 25px;\n    background: #fff;\n    box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n  }\n  .campaign-billboard-add-section {\n    display: flex;\n    margin-right: 0.5rem;\n\n    padding: 0.75rem;\n    justify-content: center;\n    align-items: center;\n    gap: 1rem;\n  }\n}\n\n@media (max-width: 375px) {\n  .ai-recommondations {\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 1440px) {\n  .billboards-image {\n    border-radius: 8;\n    width: 5.875rem;\n    height: 7.125rem;\n  }\n  .campaign-icons {\n    height: 28px;\n    width: 28px;\n  }\n\n  .billboard-values {\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .billboards-image {\n    border-radius: 8;\n    width: 5.875rem !important;\n    height: 7.125rem !important;\n  }\n}\n@media (max-width: 1024px) {\n  .billBoards-table {\n    position: relative;\n  }\n\n  .billboard-status {\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    padding: 4px 8px;\n    background-color: #d2042d;\n    color: white;\n    font-weight: bold;\n    border-radius: 0rem 0rem 0rem 0.625rem;\n    z-index: 10;\n    height: 40px;\n  }\n\n  .billboard-status.available {\n    color: #000;\n    background-color: #b0d9c4;\n  }\n\n  .billboard-status.sold-out {\n    background-color: #d2042d;\n  }\n\n  .billboards-table-header {\n    justify-content: flex-start !important;\n  }\n  .re-designed-product-col {\n    width: 100% !important;\n  }\n  .re-designed-image-container {\n    width: 13% !important;\n  }\n  .product-available-offer-action-col {\n    width: 100% !important;\n  }\n  .re-designed-campaign-price-actions-div {\n    display: flex;\n    justify-content: flex-end;\n  }\n  .campaign-total-price-section {\n    margin-right: 0% !important;\n  }\n  .campaign-quantity-controls {\n    gap: 1%;\n    align-items: center;\n    justify-content: flex-end;\n  }\n  .common-text-color-red-10 {\n    display: flex;\n    justify-content: flex-end;\n  }\n  .unit-quantitiy {\n    margin-top: 0px;\n  }\n}\n@media (max-width: 768px) {\n  .re-designed-image-container {\n    width: 20% !important;\n  }\n  .campaign-quantity-controls {\n    gap: 2%;\n    align-items: center;\n    justify-content: flex-end;\n  }\n}\n@media (max-width: 425px) {\n  .re-designed-image-container {\n    width: 33% !important;\n  }\n  .mobile-response-details-col {\n    display: flex;\n    flex-direction: column !important;\n    align-items: flex-end !important;\n  }\n  .campaign-product-details-row {\n    justify-content: space-between !important;\n  }\n  .campaign-quantity-controls {\n    gap: 3%;\n    align-items: center;\n    justify-content: flex-end;\n  }\n}\n@media (max-width: 375px) {\n  .re-designed-product-col {\n    width: 100% !important;\n    flex-direction: column !important;\n  }\n  .campaign-details-page-alignment-col {\n    width: 100% !important;\n  }\n  .re-designed-image-container {\n    width: 20% !important;\n  }\n  .mobile-response-details-col {\n    display: flex;\n    flex-direction: column !important;\n    align-items: flex-end !important;\n  }\n  .campaign-product-details-row {\n    justify-content: space-between !important;\n  }\n  .campaign-more-actions-mobile-container {\n    max-width: 100%;\n    overflow-x: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
